export const timezones = [
  'US/Eastern',
  'US/Central',
  'US/Mountain',
  'US/Arizona',
  'US/Pacific',
  'US/Alaska',
  'US/Hawaii',
];
// eslint-disable-next-line max-len
export const initialTimezone = defaultTimezone =>
  timezones.indexOf(defaultTimezone) >= 0 ? defaultTimezone : timezones[0];

export const timeFormatOptions = {
  day: 'numeric',
  hour: 'numeric',
  hour12: true,
  minute: 'numeric',
  month: 'numeric',
  year: 'numeric',
};
